<template>
  <div class="action-container action-item">
    <button
      v-for="(item, index) in items"
      :key="index"
      :class="['btn', {
        'active': type === item.value
      }]"
      @click="onSelect(item)"
    >
      <span v-html="item.icon"/>
      <span>{{ $t(item.text) }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseFilterDataType',

  props: ['type', 'items'],

  methods: {
    onSelect ({ text, value }) {
      this.$emit('onSelect', { text, value })
    },
  },
}
</script>

<style scoped>
.action-container {
  display: inline-flex;
}

.btn {
  display: flex;
  align-items: center;
  height: 21px;
  padding: 0;
  margin-right: 16px;
  background: none;
  box-shadow: none;
}

.btn:last-of-type {
  margin-right: 4px;
}

.btn /deep/ span {
  display: flex;
  align-items: center;
  color: #6c757d;
  margin-right: 6px;
}

.btn /deep/ span i {
  position: relative;
}

.btn /deep/ span:last-of-type {
  margin-right: 0;
}

/* .btn.active /deep/ span {
  color: var(--link-color);
} */

.btn.active /deep/ span i::after {
  position: absolute;
  content: '';
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  background-color: var(--link-color);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseFilterDataType.vue